import arrowIcon from '@/assets/img/newIndex/arrow.png';
import searchDropdownIcon from '@/assets/img/newIndex/xiala.png';
import localeSwitchIcon from '@/assets/img/newIndex/yyqiehuan.png';
import newsHarborNightImage from '@/assets/img/newIndex/青岛海港夜景全景.png';
import newsCoastSunsetImage from '@/assets/img/newIndex/青岛海岸日落天际线.png';
import newsBridgeSunsetImage from '@/assets/img/newIndex/胶州湾跨海大桥夕阳.png';
import spotStoryImage from '@/assets/img/newIndex/青岛故事.png';
import spotYoungImage from '@/assets/img/newIndex/青岛超有YOUNG.png';
import spotReadingImage from '@/assets/img/newIndex/全民阅读.png';
import spotYouthRankImage from '@/assets/img/newIndex/青年榜YOUNG.png';
import vrImage1 from '@/assets/img/newIndex/vr1.png';
import vrImage2 from '@/assets/img/newIndex/vr2.png';
import vrImage3 from '@/assets/img/newIndex/vr3.png';
import vrImage4 from '@/assets/img/newIndex/vr4.png';
import vrImage5 from '@/assets/img/newIndex/vr5.png';
import vrImage6 from '@/assets/img/newIndex/vr6.png';
import sloganBannerImage from '@/assets/img/newIndex/slogan-banner.png';
import iconDailyScene from '@/assets/img/newIndex/每日一景.png';
import iconPhotoPicks from '@/assets/img/newIndex/摄影精选.png';
import iconOnlineConsult from '@/assets/img/newIndex/在线咨询.png';
import iconResidenceRegister from '@/assets/img/newIndex/居住登记.png';
import iconOnlineView from '@/assets/img/newIndex/在线查看.png';
import iconProgressQuery from '@/assets/img/newIndex/进展查询.png';
import iconStudentPermit from '@/assets/img/newIndex/学生许可.png';
import iconExtendPermit from '@/assets/img/newIndex/扩展许可.png';
import iconPassportChange from '@/assets/img/newIndex/护照更改.png';
import iconAddressChange from '@/assets/img/newIndex/地址变更.png';

export const newIndexArrowIcon = arrowIcon;
export const newIndexSearchDropdownIcon = searchDropdownIcon;
export const newIndexLocaleSwitchIcon = localeSwitchIcon;

export const newIndexNewsImages = {
  harborNight: newsHarborNightImage,
  coastSunset: newsCoastSunsetImage,
  bridgeSunset: newsBridgeSunsetImage,
};

export const newIndexSpotImages = {
  story: spotStoryImage,
  young: spotYoungImage,
  reading: spotReadingImage,
  youthRank: spotYouthRankImage,
};

export const newIndexVrImages = {
  vr1: vrImage1,
  vr2: vrImage2,
  vr3: vrImage3,
  vr4: vrImage4,
  vr5: vrImage5,
  vr6: vrImage6,
};

export const newIndexSloganBannerImage = sloganBannerImage;

export const newIndexTeaserIcons = {
  daily: iconDailyScene,
  weekly: iconPhotoPicks
};

export const newIndexServiceIcons = {
  'srv-1': iconOnlineConsult,
  'srv-2': iconResidenceRegister,
  'srv-3': iconOnlineView,
  'srv-4': iconProgressQuery,
  'srv-5': iconStudentPermit,
  'srv-6': iconExtendPermit,
  'srv-7': iconPassportChange,
  'srv-8': iconAddressChange
};

export function getServiceIcon(id) {
  return newIndexServiceIcons[id] || newIndexServiceIcons['srv-1'];
}
